import React from "react";
import Wrapper from "./vendor/Wrapper";
import Header from "./sections/Header";
import WhyUs from "./sections/WhyUs";
import HowItWorks from "./sections/HowItWorks";
import TeacherJoin from "./sections/TeacherJoin";
// import Footer from "./sections/Footer";
import Gutter from "./components/Gutter";
import MainArt from "./components/MainArt";
import Metas from "../../Component/Metas";

export default function index(props) {
  return (
    <Wrapper direction="rtl">
      <Metas
        title="آموزش آنلاین زبان | لینگوتاک معلم خصوصی زبان شما"
        description="آموزش آنلاین زبان با لینگوتاک – معلم خصوصی زبان خود را داشته باشید و در کلاس خصوصی زبان خودتان شرکت کنید. یادگیری ساده، مطمئن و آسان زبان با لینگوتاک"
      />
      <MainArt />
      <Header />
      <WhyUs />
      <Gutter />
      <HowItWorks />
      <Gutter />
      <Gutter />
      <TeacherJoin />
      {/* <Gutter /> */}
      {/* <Footer /> */}
    </Wrapper>
  );
}
